import { render, staticRenderFns } from "./cashReceipt.vue?vue&type=template&id=422b2be9&scoped=true&"
import script from "./cashReceipt.vue?vue&type=script&lang=js&"
export * from "./cashReceipt.vue?vue&type=script&lang=js&"
import style0 from "./cashReceipt.vue?vue&type=style&index=0&id=422b2be9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422b2be9",
  null
  
)

export default component.exports